var React = require('react');

function EnvelopeSimple (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 7H28V24C28 24.2652 27.8946 24.5196 27.7071 24.7071C27.5196 24.8946 27.2652 25 27 25H5C4.73478 25 4.48043 24.8946 4.29289 24.7071C4.10536 24.5196 4 24.2652 4 24V7Z","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M28 7L16 18L4 7","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

EnvelopeSimple.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = EnvelopeSimple;

EnvelopeSimple.default = EnvelopeSimple;
